import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-criteria-met',
  templateUrl: './all-criteria-met.component.html',
  styleUrls: ['./all-criteria-met.component.scss']
})
export class AllCriteriaMetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
